<template>
  <div
    v-if="!hideMe"
    class="spl-parcel-detail-block">
    <div v-if="content.Tags && content.Tags.length > 0 && userHasPermission(constants.PERMISSION_TYPES.TAG, constants.PERMISSION_VALUES.LIST)">
      <div class="spl-parcel-detail-block__label">
        Tags
      </div>
      <ul class="spl-parcel-detail-routing__tag-list">
        <p
          v-for="tag in content.Tags"
          :key="'detail-tag-' + tag.Tag_ID"
          class="spl-parcel-detail-routing__tag-list__item">
          {{ tag.Tag_Name }}
        </p>
      </ul>
    </div>
    <div v-if="content.Providers && content.Providers.length > 0 && userHasPermission(constants.PERMISSION_TYPES.PROVIDER, constants.PERMISSION_VALUES.LIST)">
      <div class="spl-parcel-detail-block__label">
        Providers
      </div>
      <ul class="spl-parcel-detail-routing__tag-list">
        <p
          v-for="provider in content.Providers"
          :key="'detail-tag-' + provider.Provider_ID"
          class="spl-parcel-detail-routing__tag-list__item">
          {{ provider.Provider_Name }}
        </p>
      </ul>
    </div>
    <div v-if="highlight" class="spl-parcel-detail-block__highlight">
      {{ highlight }}
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import webApi from '@/webApi'
import constants from '@/constants'
export default {
  name: 'ParcelDetailBlock',
  mixins: [Helpers],
  props: [
    'label',
    'highlight',
    'content'
  ],
  data () {
    return {
      isEditing: false,
      tempBlockContent: this.cloneArray(this.content),
      changedValueIndices: [],
      constants,
      hideMe: false,
      saving: false
    }
  },
  computed: {
    blockContent () {
      return this.content
    },
    parcel_json () {
      return this.originalParcelJson
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-detail-block {
        background-color: $parcelTimelineBackgroundColor;
        margin-bottom: 20px;
        padding: 20px 17px 30px 17px;
        position: relative;
        width: 100%;
    }
    .spl-parcel-detail-routing {
      &__tag-list {
        margin: 0 0 10px 0;
        padding: 0;

        &__item {
          position: relative;
          display: inline-block;
          padding: 4px 10px 4px 10px;
          margin: 0 10px 5px 0;
          border-radius: 5px;
          font-size: 13px;
          color: black;
          line-height: 1;
          background: $middleYellow;
          white-space: nowrap;
          overflow: hidden;
          max-width: 100%;
          text-overflow: ellipsis;
        }
      }
    }
</style>
